import React, {useEffect, useState} from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import { getNumberMessages, setMessages, setChatSelected, setTalentSelected, setJobSelected, setTextInput,
  setPendingPath, setIsDiscardUnsentMessagePopup, setIsNewChatFormOtherScreen,
  setIsChatting, setIsSameChatSelected,
  setIsMessageFormDirty, } from "reducers/chatMessage";
import { setIsPanelDetailTalentOpen, setIsOpenRegisterPanel, setSelectedRows, setDisplaySelectedCount } from "reducers/companyTalent";
import {ThunkDispatch} from "@reduxjs/toolkit";
import { PERMISSIONS } from '../constants/index';
import ConfirmPopup from "./ConfirmPopup";
import { AnimatePresence, motion } from "framer-motion";
import { setIsFromTagsList } from "reducers/talentTag";
import UnsaveConfirmPopup from "../pages/action/components/UnsaveConfirmPopup";
import { setShowLeaveConfirm, setIsFormDirty, setOtherPendingPath, setIsNavigatingAway } from "reducers/app";
import { setJobDetailDataTemp, setJobDetailData, setIsPublishedItem } from "reducers/companyJob";

const menuItems = [
  {
    name: "ホーム",
    path: "/company",
  },
  {
    name: "タレント",
    path: "/company/talent",
    childPath: [
      "/company/talent/register",
      "/company/talent/import",
      "/company/talent/tags",
      "/company/talent/register-link",
    ],
    subMenu: [
      {
        name: "タレント管理",
        path: "/company/talent"
      },
      {
        name: "登録申請",
        path: "/company/talent/register"
      },
      {
        name: "タレントタグ管理",
        path: "/company/talent/tags"
      },
      {
        name: "登録リンク管理",
        path: "/company/talent/register-link"
      }
    ]
  },
  {
    name: "求人",
    path: "/company/job",
    childPath: [
      "/company/job/register",
      "/company/job/edit/:id",
      "/company/job/detail/:id",
      "/company/job/preview/:id",
      "/company/job/import",
      "/company/job/preview-temp/:id",
    ],
    menu: PERMISSIONS.JOB_MENU,
  },
  {
    name: "メッセージ",
    path: "/company/message",
    noti: 0,
  },
  {
    name: "コンテンツ",
    path: "/company/content",
    childPath: [
      "/company/notification-setting",
      "/company/news/register",
      "/company/news/edit/:id",
      "/company/news/detail/:id",
      "/company/content-ranking",
    ],
    menu: PERMISSIONS.NEWS_MENU,
  },
  {
    name: "アクション管理",
    path: "/company/action",
    childPath: [
      "/company/action/edit/:id",
    ],
    menu: PERMISSIONS.ACTION_MENU,
  },
  {
    name: "管理ユーザー",
    path: "/company/staff",
    menu: PERMISSIONS.USER_MENU,
  },
  {
    name: "操作履歴",
    path: "/company/history",
    menu: PERMISSIONS.HISTORY_MENU,
  },
];

const MenuItem = ({ item, isItemSelected }: any) => {
  const location = useLocation();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const navigate = useNavigate();
  const currentUser = useSelector((state: any) => state.currentUser);
  const { staffPermission } = currentUser;
  const { numberOfMessage, textInput, isDiscardUnsentMessagePopup, isMessageFormDirty, globalFilterString } = useSelector((state: any) => state.chatMessage);
  const {isFormDirty, showLeaveConfirm} = useSelector((state: any) => state.app);
  const havingSubMenu = item.subMenu && item.subMenu.length > 0;
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(isItemSelected);
  const { isPublishedItem } = useSelector((state: any) => state.companyJob);

  const handleClick = (e:any, path, isSubMenu: boolean) => {
    e.preventDefault();

    if (isPublishedItem) {
      dispatch(setIsPublishedItem(false));
    }
    dispatch(setIsPanelDetailTalentOpen(false));
    dispatch(setIsOpenRegisterPanel(false));
    dispatch(setSelectedRows([]));
    dispatch(setDisplaySelectedCount(0));

    if(path != "/company/talent/tags") {
      dispatch(setIsFromTagsList(false));
    }

    if(havingSubMenu && !isSubMenu) {
      setIsSubMenuOpen(prev => !prev);
      return;
    }
    
    if(path == "/company/message" && !isFormDirty) {
      dispatch(setChatSelected({}));
      dispatch(setIsChatting(false));
      dispatch(setIsSameChatSelected(true));
      dispatch(setIsNewChatFormOtherScreen(false));
      navigate(path);
      return;
    }

    if(location.pathname === "/company/message") {
      if(isMessageFormDirty && !isDiscardUnsentMessagePopup) {
        dispatch(setIsDiscardUnsentMessagePopup(true));
        dispatch(setPendingPath(path));
      } else {
        dispatch(setIsSameChatSelected(false));
        dispatch(setChatSelected({}));
        dispatch(setTalentSelected({}));
        dispatch(setJobSelected({}));
        dispatch(setMessages([]));
        dispatch(setTextInput(""));
        navigate(path, {
          state: { fromMenu: true }
        });
      }
    } else {
      if(isFormDirty && !showLeaveConfirm) {
        dispatch(setOtherPendingPath(path));
        dispatch(setShowLeaveConfirm(true));
        dispatch(setIsNavigatingAway(true));
        return;
      } else {
        navigate(path, {
          state: { fromMenu: true }
        });
      }
    }
    
  };

  const variants = {
    collapsed: { 
      opacity: 0, 
      clipPath: "inset(0 0 100% 0)", 
      transition: { duration: 0.25, ease: "easeInOut" } 
    },
    open: { 
      opacity: 1, 
      clipPath: "inset(0 0 0% 0)", 
      transition: { duration: 0.35, ease: [0.25, 0.8, 0.25, 1] } 
    },
  };

  if(item.menu && !staffPermission[item.menu])
    return (<></>)
  else
    return (
      <>
        <li
          className={`h-12 px-3 py-[0.875rem] rounded flex items-center justify-between gap-2 ${
            isItemSelected && !havingSubMenu ? "hover:cursor-default" : "hover:bg-[#FFF3E5] hover:cursor-pointer group hover:!text-[#FF861A] transition-colors duration-200"
          } ${!item?.name ? "invisible" : ""} ${!isItemSelected ? "alu-text-base-1" : "text-[#343A3D]"}`}
          onClick={(e) => !isItemSelected && handleClick(e, item.path, false)}
        >
          <p
            className={`text-sm leading-[1.3125rem] font-bold`}
          >
            {item?.name}
          </p>
          {item?.noti != undefined && numberOfMessage != 0 && (
            <span className="shrink-0 px-[0.375rem] py-[0.125rem] rounded-full bg-alu-primary text-white text-[0.625rem] leading-[0.9375rem] font-bold flex items-center justify-center object">
              {numberOfMessage >= 100 ? "99+" : numberOfMessage }
            </span>
          )}
          {havingSubMenu && (
            <span className={`transition-transform duration-300 text-inherit ${isSubMenuOpen ? "rotate-0" : "rotate-180"}`}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M4.94 10.2733L8 7.22001L11.06 10.2733L12 9.33335L8 5.33335L4 9.33335L4.94 10.2733Z" fill="currentColor"/>
              </svg>
            </span>
          )}
        </li>
        <AnimatePresence initial={false}>
          {havingSubMenu && isSubMenuOpen && (
            <motion.ul
              className="flex flex-col gap-2 py-2 overflow-hidden will-change-transform"
              variants={variants}
              initial="collapsed"
              animate="open"
              exit="collapsed"
            >
              {item.subMenu.map((subItem, idx) => (
                <li
                  key={idx}
                  onClick={(e) => handleClick(e, subItem.path, true)}
                  className={`h-7 px-[1.125rem] py-1 rounded flex items-center ${
                    location.pathname === subItem.path
                      ? "hover:cursor-default"
                      : "hover:bg-[#FFF3E5] hover:font-bold group hover:cursor-pointer"
                  }`}
                >
                  <p
                    className={`text-xs leading-[1.125rem] ${
                      location.pathname === subItem.path
                        ? "alu-text-base-2 font-bold"
                        : "alu-text-base-1"
                    } group-hover:text-[#FF861A]`}
                  >
                    {subItem?.name}
                  </p>
                </li>
              ))}
            </motion.ul>
          )}
        </AnimatePresence>
      </>
    );
};

const CompanySideMenu = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const { isDiscardUnsentMessagePopup, pendingPath, isScout } = useSelector((state: any) => state.chatMessage);
  const {showLeaveConfirm, otherPendingPath, isNavigatingAway} = useSelector((state: any) => state.app);

  useEffect(() => {
    // Get number of messages not read
    dispatch(getNumberMessages(""));
  }, []);

  const handleConfirmDiscardUnsentMessage = () => {
    dispatch(setIsSameChatSelected(false));
    dispatch(setChatSelected({}));
    dispatch(setTalentSelected({}));
    dispatch(setJobSelected({}));
    dispatch(setMessages([]));
    dispatch(setPendingPath(""));
    dispatch(setTextInput(""));
    dispatch(setIsDiscardUnsentMessagePopup(false));
    dispatch(setIsMessageFormDirty(false));

    if(pendingPath) {
      navigate(pendingPath);
    }
  }

  const handleConfirmDiscard = () => {
    if(otherPendingPath) {
      dispatch(setShowLeaveConfirm(false));
      dispatch(setIsFormDirty(false));
      dispatch(setIsNavigatingAway(false));
      dispatch(setJobDetailDataTemp(null));
      dispatch(setJobDetailData([]));
      navigate(otherPendingPath);
    }
  }

  return (
    <><ul className="h-max w-[10rem] bg-white px-2 py-8 flex flex-col gap-2 rounded-2xl shrink-0 alu-section-box-shadow">
      {menuItems.map((item, idx) => {
        return (
          <MenuItem
            key={idx}
            item={item}
            isItemSelected={
              location.pathname === item.path ||
              (item.path === "/company" && location.pathname === "/company/") ||
              (item.childPath && item.childPath.some(childPath => {
                const regex = new RegExp(`^${childPath.replace(/\/:\w+$/, '/\\d+')}$`);
                return regex.test(location.pathname);
              }))
            }
          />
        )}
      )}
    </ul>
      {isDiscardUnsentMessagePopup && <UnsaveConfirmPopup
        open={isDiscardUnsentMessagePopup}
        onClose={() => dispatch(setIsDiscardUnsentMessagePopup(false))}
        confirmContent={"編集中の内容を保存せずに終了しますか？"}
        onOtherAction={handleConfirmDiscardUnsentMessage}
      />}
      {showLeaveConfirm && isNavigatingAway && <UnsaveConfirmPopup
        open={showLeaveConfirm}
        onClose={() => dispatch(setShowLeaveConfirm(false))}
        confirmContent={"編集中の内容を保存せずに終了しますか？"}
        onOtherAction={() => handleConfirmDiscard()}
      />}
    </>
  );
};

export default CompanySideMenu;
